export { default } from "./BoxType";
